"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.Carousel = void 0;
var react_1 = __importDefault(require("react"));
var react_slick_1 = __importDefault(require("react-slick"));
// Added those manually to remove the font dependencies which keeps showing 404 not found
require("../../../../../../assets/slick/slick-theme.css");
require("../../../../../../assets/slick/slick.css");
var utils_1 = require("../../../utils");
var CarouselSkeleton = function () {
    var common = { width: '100%', borderRadius: 5, padding: 10 };
    var button = __assign({ height: 30, backgroundColor: '#ecebeb', marginTop: 10 }, common);
    return (react_1.default.createElement("div", { className: "bpw-carousel-skeleton", style: __assign({ height: 380, backgroundColor: '#f3f3f3' }, common) },
        react_1.default.createElement("div", { style: __assign({ height: 280, backgroundColor: '#ecebeb' }, common) }),
        react_1.default.createElement("div", { style: button }),
        react_1.default.createElement("div", { style: button })));
};
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            adjustedWidth: 0
        };
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ adjustedWidth: this.ref.offsetWidth - window.innerWidth });
        // Reset this to avoid incorrect values when closing-opening the webchat
        setTimeout(function () {
            _this.setState({
                adjustedWidth: _this.ref.offsetWidth - window.innerWidth
            });
        }, 300);
    };
    Carousel.prototype.renderCarousel = function () {
        var _this = this;
        var carousel = this.props.carousel;
        var elements = carousel.elements || [];
        // Breakpoints must be adjusted since the carousel is based on the page width, and not its parent component
        var adjustBreakpoint = function (size) { return size - _this.state.adjustedWidth; };
        var defaultSettings = {
            dots: false,
            infinite: false,
            responsive: __spreadArray([], Array(10), true).map(function (_, i) { return ({
                breakpoint: adjustBreakpoint(550 + i * 524),
                settings: { slidesToShow: i + 1 }
            }); }),
            slidesToScroll: 1,
            autoplay: false,
            centerMode: false,
            arrows: elements.length > 1
        };
        var settings = Object.assign({}, defaultSettings, carousel === null || carousel === void 0 ? void 0 : carousel.settings);
        return (react_1.default.createElement(react_slick_1.default, __assign({ key: this.state.adjustedWidth }, settings), elements.map(function (el, idx) { return (react_1.default.createElement(exports.Card, { element: el, key: idx, onSendData: _this.props.onSendData, escapeHTML: _this.props.escapeHTML, isBotMessage: _this.props.isBotMessage, intl: _this.props.intl })); })));
    };
    Carousel.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { ref: function (el) { return (_this.ref = el); }, style: __assign({ width: '100%' }, this.props.style) }, (this.state.adjustedWidth && this.renderCarousel()) || react_1.default.createElement(CarouselSkeleton, null)));
    };
    return Carousel;
}(react_1.default.Component));
exports.Carousel = Carousel;
var Card = function (props) {
    var _a = props.element, picture = _a.picture, title = _a.title, subtitle = _a.subtitle, buttons = _a.buttons, markdown = _a.markdown;
    var escapeHTML = props.escapeHTML, intl = props.intl;
    return (react_1.default.createElement("div", { className: 'bpw-card-container' },
        picture && react_1.default.createElement("div", { className: 'bpw-card-picture', style: { backgroundImage: "url(\"".concat(picture, "\")") } }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'bpw-card-header' },
                react_1.default.createElement(utils_1.ProcessedText, { wrapperProps: {
                        className: 'bpw-card-title',
                        tag: 'div'
                    }, isBotMessage: props.isBotMessage, markdown: markdown, escapeHTML: escapeHTML }, title),
                subtitle && (react_1.default.createElement(utils_1.ProcessedText, { wrapperProps: {
                        className: 'bpw-card-subtitle',
                        tag: 'div'
                    }, isBotMessage: props.isBotMessage, markdown: markdown, escapeHTML: escapeHTML, intl: props.intl }, subtitle))),
            react_1.default.createElement("div", { className: 'bpw-card-buttons' }, buttons.map(function (btn) {
                var _a, _b;
                if (btn.url) {
                    return (react_1.default.createElement("a", { href: btn.url, key: "1-".concat(btn.title), target: /^javascript:/.test(btn.url) ? '_self' : '_blank', className: 'bpw-card-action' },
                        btn.title || btn,
                        /^javascript:/.test(btn.url) ? null : react_1.default.createElement("i", { className: 'bpw-card-external-icon' })));
                }
                else if (btn.type === 'postback' || btn.payload) {
                    return (react_1.default.createElement("a", { onClick: (_a = props.onSendData) === null || _a === void 0 ? void 0 : _a.bind(_this, { type: 'postback', payload: btn.payload }), key: "2-".concat(btn.title), className: 'bpw-card-action' }, btn.title || btn));
                }
                else if (btn.type === 'say_something' || btn.text) {
                    return (react_1.default.createElement("a", { onClick: (_b = props.onSendData) === null || _b === void 0 ? void 0 : _b.bind(_this, { type: 'say_something', text: btn.text }), key: "2-".concat(btn.title), className: 'bpw-card-action' }, btn.title || btn));
                }
                else {
                    return (react_1.default.createElement("a", { href: '#', key: "3-".concat(btn.title), target: '_blank', className: 'bpw-card-action' },
                        btn.title || btn,
                        react_1.default.createElement("i", { className: 'bpw-card-external-icon' })));
                }
            })))));
};
exports.Card = Card;
